<template>
  <FaIcon :icon="['far', DEVICE_DEFAULT_OUTPUT_ICON]" />
</template>

<script setup lang="ts">
import { DEVICE_DEFAULT_OUTPUT_ICON } from '@/constants/device';
</script>
